import React, { Component } from 'react'
import { Container, Row, Col } from 'reactstrap'
import Link from '../../atoms/LinkNoPadding'
import { FaDownload } from 'react-icons/fa';

export const DownloadLink = ({ children, href, ...props }) => {
    return (
      <div>
          <FaDownload/><br class="d-flex d-md-none" />
          <Link target="_blank" href={href}>
            { children }
          </Link>
      </div>
    )
  }

  export default DownloadLink



// WEBPACK FOOTER //
// ./src/components/molecules/DownloadLink/DownloadLink.js